import './loading.scss';

import React, { Fragment } from 'react';

interface IProp {
  info?: string | null;
}

export function Loading({ info }: IProp) {
  return (
    <div className="loading">
      loading
      <span className="loading-dot">.</span>
      <span className="loading-dot">.</span>
      <span className="loading-dot">.</span>
      {info && (
        <Fragment>
          <br />
          <span className="loading-info">{info}</span>
        </Fragment>
      )}
    </div>
  );
}
